<template>
  <div id="FindEntitlementsForm" class="card">
    <div class="card-header">
      {{ getContentItem("FindEntitlements") }}
    </div>
    <div class="card-body">
      <form @submit.prevent="search">
        <p class="card-text">
          {{ getContentItem('FindEntitlementMessage') }}
        </p>
        
        <b-input-group>
          <b-form-input
            v-model="searchTerm"
            type="text"
            class="form-control"
            aria-describedby="searchTerm"
          />
          <div class="input-group-append">
            <b-button 
              variant="dark" 
              :disabled="(searchTerm === '' )" 
              type="submit"
            >
              {{ getContentItem('goButton') }}
            </b-button>
          </div>
        </b-input-group>
      </form>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";

  export default {
    name: "FindEntitlements",
    props: {
      oemPartCode: { type: String, default: "" }
    },
    data: function() {
      return {
        searchTerm: "",
      };
    },
    computed: {
      ...mapGetters(["getContentItem"]),
    },
    created () {
      if (this.oemPartCode) {
        this.searchTerm = this.oemPartCode;
      }
    },
    methods: {
      search() {
        // trim and uppercase the search term, then remove any trailing "R"
        this.searchTerm = this.searchTerm.trim().toUpperCase()
        if( this.searchTerm.substring(this.searchTerm.length - 1) === "R"){
          this.searchTerm = this.searchTerm.substring(0, this.searchTerm.length - 1)
        }

        this.$router.push({ name: "Entitlements", query: { oemPartCode: this.searchTerm } });
      }
    }
  };
</script>